'use client';

import { HUB_URL } from './const';
import { useSignalRHub } from './context/useSignalRHub';

export enum TelemetryHubEvents {
  // the information will be received on another hub - not sure why.
  SEND_RELAY_RESEND_REQUEST = 'SendRelayResendRequest',
  RECEIVE_NOTIFICATION = 'ReceiveNotification',
  RECEIVE_NETWORK_HEALTH = 'ReceiveNetworkHealth',
}

/**
 * Hook to use for the Telemetry hub
 */
export function useTelemetryHub() {
  return useSignalRHub(HUB_URL.TELEMETRY);
}
